import rocketIcon from "../../assets/helpIcons/rocket.png";
import calendarIcon from "../../assets/helpIcons/calendar.png";
import userIcon from "../../assets/helpIcons/user.png";
import linkIcon from "../../assets/helpIcons/link.png";
import clipboardIcon from "../../assets/helpIcons/clipboard.png";
import shieldIcon from "../../assets/helpIcons/shield.png";
import documentIcon from "../../assets/helpIcons/document.png";

const iconMap = {
  rocket: rocketIcon,
  calendar: calendarIcon,
  user: userIcon,
  link: linkIcon,
  clipboard: clipboardIcon,
  shield: shieldIcon,
  document: documentIcon,
};

const HelpCenterCard = ({ section, onClick, variant = "default" }) => {
  const icon = iconMap[section.icon];

  if (variant === "training" || variant === "training-age") {
    const isAgeCard = variant === "training-age";

    return (
      <button
        type="button"
        onClick={onClick}
        className={`h-full w-full rounded-lg border border-gray-200 bg-white pb-4 pl-5 pr-12 pt-4 text-center text-gray-900 shadow-md transition-all duration-200 hover:border-blue-300 hover:shadow-xl ${
          isAgeCard ? "min-h-28" : "min-h-24"
        }`}
      >
        <span className={`${isAgeCard ? "text-base" : "text-lg"} font-medium leading-snug`}>
          {section.cardTitle || section.title}
        </span>
      </button>
    );
  }

  return (
    <div
      onClick={onClick}
      className="h-full cursor-pointer rounded-xl border border-gray-200 bg-white p-6 shadow-md transition-all duration-200 hover:border-blue-300 hover:bg-blue-50/30 hover:shadow-xl"
    >
      <div className="mb-4 flex items-center gap-4 pr-10">
        {icon && (
          <img
            src={icon}
            alt=""
            className="w-14 h-14 flex-shrink-0"
          />
        )}

        <h3 className="text-lg font-semibold">
          {section.title}
        </h3>
      </div>

      <p className="text-gray-600">
        {section.description}
      </p>
    </div>
  );
};

export default HelpCenterCard;
